import { Coordinate } from "~/bff/types/Coordinate";

export enum CountryCode {
  AT = "AT",
  BE = "BE",
  CZ = "CZ",
  DE = "DE",
  ES = "ES",
  FR = "FR",
  IE = "IE",
  US = "US",
  NL = "NL",
  PL = "PL",
  GB = "GB",
  PT = "PT",
  SI = "SI",
  IT = "IT",
  SK = "SK",
  RO = "RO",
}

export interface Country {
  code2: CountryCode;
  code3: string;
  number: string;
  zoom?: number;
  coordinates?: Coordinate;
}
